export interface Event {
  date: Date
  copy: JSX.Element
}

export const EVENTS: Event[] = [
  {
    date: new Date('2023-06-11T00:00:00'),
    copy: <><p>Today's puzzle is brought to you by <a className="text-indigo-700 dark:text-indigo-400 font-bold" href="https://www.stepdle.com/">Stepdle</a></p><p>Guess the 4, 5, 6, and 7 letter word in 20 tries!</p></>,
  },
]
